/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  StatusFragmentDoc,
  CategoryFragmentDoc,
} from "../../app/ProjectLabels.generated";
export type TableListFragment = {
  readonly __typename: "DataSourceTable";
  readonly id: c.DataSourceTableId;
  readonly name: string;
  readonly comment: string | null;
  readonly columnCount: number;
  readonly dataConnectionId: c.DataConnectionId;
  readonly tableType: Types.TableType | null;
  readonly dbtDescriptionMdStripped: string | null;
  readonly pinned: boolean;
  readonly pinnedAt: c.DateTimeString | null;
  readonly metadata: {
    readonly __typename: "DataSourceTableMetadata";
    readonly id: c.DataSourceTableMetadataId;
    readonly magicDescription: string | null;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    } | null;
    readonly categories: ReadonlyArray<{
      readonly __typename: "Category";
      readonly id: c.CategoryId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
    }>;
  } | null;
  readonly dataSourceSchema: {
    readonly __typename: "DataSourceSchema";
    readonly id: c.DataSourceSchemaId;
    readonly name: string;
    readonly dataSourceDatabase: {
      readonly __typename: "DataSourceDatabase";
      readonly id: c.DataSourceDatabaseId;
      readonly name: string | null;
    };
  };
};

export const TableListFragmentDoc = /*#__PURE__*/ gql`
  fragment TableListFragment on DataSourceTable {
    id
    name
    comment
    columnCount
    dataConnectionId
    tableType
    metadata {
      id
      magicDescription
      status {
        ...StatusFragment
      }
      categories {
        ...CategoryFragment
      }
    }
    dbtDescriptionMdStripped
    dataSourceSchema {
      id
      name
      dataSourceDatabase {
        id
        name
      }
    }
    pinned
    pinnedAt
  }
  ${StatusFragmentDoc}
  ${CategoryFragmentDoc}
`;
